import { render, staticRenderFns } from "./TopRegional.vue?vue&type=template&id=543f31ab&scoped=true"
import script from "./TopRegional.vue?vue&type=script&lang=js"
export * from "./TopRegional.vue?vue&type=script&lang=js"
import style0 from "./TopRegional.vue?vue&type=style&index=0&id=543f31ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543f31ab",
  null
  
)

export default component.exports